import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import CKEditor from 'ckeditor4-react'
import { GlgPopup, GlgSwitch, GlgRangeSlider } from 'SharedComponents'
import { Row, Col } from 'react-flexbox-grid'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { NONE, ADVANCED_TYPE, LEADERBOARD_TYPE, HEADER_VARS } from '../../constants'
import { gridItemCompare, computeLayout, ckeditorMinimalistToolbar, initialSlideState } from '../../helpers'

const ResponsiveGridLayout = WidthProvider(Responsive)

class AdvancedSlidePopupComponent extends Component {
  constructor(props) {
    super(props)

    this.state = this.initialState()

    this.pagesSettings = this.computePageSettings()

    this.setSlide = this.setSlide.bind(this)
    this.saveToDB = this.saveToDB.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.initialState = this.initialState.bind(this)
    this.setHeaderText = this.setHeaderText.bind(this)
    this.saveNewLayout = this.saveNewLayout.bind(this)
    this.initializeOnShow = this.initializeOnShow.bind(this)
    this.updateSlideInProps = this.updateSlideInProps.bind(this)
    this.openSlidesSelector = this.openSlidesSelector.bind(this)
    this.hideContainedSlides = this.hideContainedSlides.bind(this)
    this.computePageSettings = this.computePageSettings.bind(this)
    this.setNewSlideFromPopup = this.setNewSlideFromPopup.bind(this)
    this.destroyEditorInstances = this.destroyEditorInstances.bind(this)
    this.setSlideSelectorVisibility = this.setSlideSelectorVisibility.bind(this)
    this.prepareForNewSlidePopupOpen = this.prepareForNewSlidePopupOpen.bind(this)
  }

  initialState() {
    const initialLayout = {
      xs: [
        {i: 'a', x: 0, y: 0, w: 1, h: 1 },
        {i: 'b', x: 1, y: 0, w: 1, h: 1 },
      ],
    }

    return {
      isSaving: false,
      slidesSelectorOpenFor: NONE,
      currentPage: 0,
      gridItems: {
        a: {
          x: initialLayout.xs.filter( el => el.i === 'a' )[0].x,
          y: initialLayout.xs.filter( el => el.i === 'a' )[0].y,
        },
        b: {
          x: initialLayout.xs.filter( el => el.i === 'b' )[0].x,
          y: initialLayout.xs.filter( el => el.i === 'b' )[0].y,
        },
      },
      cursorOffsetRight: 0,
      overlayPopupOpenedFor: NONE,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.initializeOnShow(prevProps, prevState)
    this.setNewSlideFromPopup(prevProps)
  }

  computePageSettings() {
    return [
      {
        saveButtonText: `${!window.I18n ? '' : window.I18n.t('buttons.next').charAt(0)
          .toUpperCase() + (!window.I18n ? '' : window.I18n.t('buttons.next').slice(1))};${!window.I18n ? '' : window.I18n.t('buttons.next').charAt(0)
          .toUpperCase() + (!window.I18n ? '' : window.I18n.t('buttons.next').slice(1))}`,
        onSave: () => {
          this.setState({
            currentPage: (this.state.currentPage + 1) % this.pagesSettings.length,
          })
        },
      },
      {
        saveButtonText: `${!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.update')};${!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.add')}`,
        onSave: () => {
          this.destroyEditorInstances()
          this.saveToDB()
          this.setState({overlayPopupOpenedFor: NONE})
        },
        customButtons: [
          {
            text: !window.I18n ? '' : window.I18n.t('buttons.back').charAt(0)
              .toUpperCase() + (!window.I18n ? '' : window.I18n.t('buttons.back').slice(1)),
            onClick: () => {
              this.setState({
                currentPage: this.state.currentPage - 1,
              })
            },
          },
        ],
      },
    ]
  }

  initializeOnShow(prevProps, prevState) {
    if (!prevProps.show && this.props.show && prevState.overlayPopupOpenedFor === NONE) {
      const newState = this.initialState()
      newState.gridItems = {
        a: _.get(this.props, 'gridItems.a', undefined) || this.initialState().gridItems.a,
        b: _.get(this.props, 'gridItems.b', undefined) || this.initialState().gridItems.b,
      }
      this.setState({ ...newState })
    }
  }

  setNewSlideFromPopup(prevProps) {
    if ( prevProps.slides.length < this.props.slides.length ) {
      this.slideAdded = _.differenceWith(this.props.slides, prevProps.slides, _.isEqual)[0]
    }
    if ( this.state.overlayPopupOpenedFor !== NONE && this.props.type === 'none' ) {
      this.props.setSlidePopupConfiguration(this.savedConfiguration)

      if (this.slideAdded) {
        this.setSlide(this.state.overlayPopupOpenedFor, this.slideAdded.id)
        this.slideAdded = undefined
      }
    }
  }

  destroyEditorInstances() {
    Object.values(this.state.gridItems).map(item => item.editorInstance)
                                       .filter( editor => editor )
                                       .forEach( editorInstance => {
                                         editorInstance.removeAllListeners()
                                         window.CKEDITOR.remove(editorInstance)
                                       } )
    const newGridItems = { ...this.state.gridItems }
    delete newGridItems.a.editorInstance
    delete newGridItems.b.editorInstance
    this.setState({ gridItems: newGridItems })
  }

  setSlideSelectorVisibility(value) {
    this.setState({ slidesSelectorOpenFor: value })
  }

  handleClose() {
    this.setState({ overlayPopupOpenedFor: NONE })
    this.props.onClose()
  }

  openSlidesSelector(event, gridItemValue) {
    const containerElement = document.getElementsByClassName('advanced-layout-container')[0].getBoundingClientRect()
    const relativeX = event.clientX - containerElement.x
    const offsetRight = containerElement.width - relativeX

    this.setState({
      cursorOffsetRight: offsetRight,
      slidesSelectorOpenFor: gridItemValue,
    })
  }

  saveNewLayout(currentLayout) {
    this.setState({
      gridItems: {
        a: {
          ...this.state.gridItems.a,
          x: currentLayout.filter( el => el.i === 'a' )[0].x,
          y: currentLayout.filter( el => el.i === 'a' )[0].y,
        },
        b: {
          ...this.state.gridItems.b,
          x: currentLayout.filter( el => el.i === 'b' )[0].x,
          y: currentLayout.filter( el => el.i === 'b' )[0].y,
        },
      },
    })
  }

  setSlide(gridItemIndex, slideId) {
    const newGridItems = { ...this.state.gridItems }
    newGridItems[gridItemIndex].slideId = slideId

    this.setState({
      slidesSelectorOpenFor: NONE,
      overlayPopupOpenedFor: NONE,
      gridItems: newGridItems,
    })
  }

  saveToDB() {
    const {
      isVisible,
      scrollRate,
      slideId,
      slides,
    } = this.props
    const { gridItems} = this.state
    const descriptions = slides.filter( slide => slide.id === gridItems.a.slideId || slide.id === gridItems.b.slideId ).map( slide => slide.description)
    const slide = {
      slideId,
      position: slides.length,
      visible: isVisible,
      type: ADVANCED_TYPE,
      description: descriptions.join(', '),
      animation: '',
      background: '',
      scrollRate: scrollRate,
      settings: {
        containedSlidesById: {
          [this.state.gridItems.a.slideId]: { ...this.state.gridItems.a },
          [this.state.gridItems.b.slideId]: { ...this.state.gridItems.b },
        },
        displayType: ADVANCED_TYPE,
      },
    }

    delete slide.settings.containedSlidesById.undefined

    this.setState({ isSaving: true })
    $.ajax({
      url: this.props.paths.saveSlide,
      type: 'POST',
      data: slide,
      success: (response) => {
        this.updateSlideInProps(slide, response.id)
        this.hideContainedSlides(slide)
        this.setState({ isSaving: true }, this.props.onClose)
      },
      error: () => {
      },
    })
  }

  updateSlideInProps(slide, idInResponse) {
    if (slide.slideId) {
      this.props.updateSlide({
        id: slide.slideId,
        type: slide.type,
        description: slide.description,
        visible: slide.visible,
        settings: slide.settings,
      })
    } else {
      this.props.addSlide({
        id: idInResponse,
        type: slide.type,
        description: slide.description,
        visible: slide.visible,
        settings: slide.settings,
      })
    }
  }

  hideContainedSlides(advancedSlide) {
    const { slides } = this.props

    const slidesToHide = slides.filter( slide =>
      Object.keys(advancedSlide.settings.containedSlidesById).includes(slide.id) &&
      slide.visible
    )

    slidesToHide.forEach( slide =>
      this.props.toggleVisibilityFor(slide)
    )
  }

  prepareForNewSlidePopupOpen() {
    const configurationProperties = Object.keys(initialSlideState(ADVANCED_TYPE))
    const propsCopy = { ...this.props }
    Object.keys(propsCopy).forEach( (property) => { !configurationProperties.includes(property) && delete propsCopy[property] } )
    this.savedConfiguration = propsCopy

    this.setState({ overlayPopupOpenedFor: this.state.slidesSelectorOpenFor })
  }

  setHeaderText(gridItemIndex, text) {
    const newState = { ...this.state }
    newState.gridItems[gridItemIndex].headerText = text

    this.setState(newState)
  }

  setEditorDefaultConfiguration(gridItemIndex, editor) {
    if ( (editor.getData() || '').length > 0) {
      return
    }

    const defaultStyle =
      `<p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 16px;">
          %tournament.name%
        </span></span>
      </p>
      <p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 16px;">
          %division.name%
        </span></span>
      </p>`

    editor.setData( defaultStyle )
    this.setHeaderText(gridItemIndex, defaultStyle)
  }

  render() {
    const {
      paths,
      slideId,
      slides,
    } = this.props

    const {
      currentPage,
      gridItems,
      isSaving,
    } = this.state

    const saveButtonEnabled = [ 
      !!gridItems.a.slideId && !!gridItems.b.slideId, 
      !!gridItems.a.editorInstance && !!gridItems.b.editorInstance,
    ]

    return (
      <GlgPopup
        title={ `${slideId ? (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.edit_advanced_slide')) : 
                             (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.new_advanced_slide')) } ` }
        show={ this.props.show }
        manualClose={ true }
        saveButtonText={ slideId ?
          this.pagesSettings[currentPage].saveButtonText.split(';')[0] :
          this.pagesSettings[currentPage].saveButtonText.split(';')[1]
        }
        saveButtonEnabled={ saveButtonEnabled[currentPage] }
        onSave={ this.pagesSettings[currentPage].onSave }
        showCloseButton={ false }
        closeButtonText={ this.pagesSettings[currentPage].closeButtonText }
        onClose={ this.handleClose }
        customButtons={ this.pagesSettings[currentPage].customButtons }
        modalClass={ 'advanced-popup' }
        isSaving={ isSaving }
      >
        <div id='slide_setup'>
          <div className='visible-switch justify-center'>
            <GlgSwitch
              id={ 'advanced-visible-switch' }
              text={ [ (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.visible')),
              (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.hidden')) ] }
              widthInPixels={ 80 }
              checked={ !!this.props.isVisible }
              onChange={ () => { this.props.setVisible(!this.props.isVisible) } } />
          </div>
          <ul className='no-padding'>
            {currentPage === 0 && (
              <li className='form_row add-margin-top-10 add-padding-bottom-10'>
                <div className='row popup-section-title'>
                  <Col xs={ 12 }>
                    { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.build_layout') }
                  </Col>
                </div>
                <div className='row popup-section no-padding-bottom'>
                  <Col className='no-padding-right' xs={ 12 }>
                    <div className='advanced-layout-container'>
                      <ResponsiveGridLayout
                        className='layout'
                        layouts={ computeLayout(gridItems) }
                        breakpoints={{xs: 1}}
                        cols={ {xs: 2 } }
                        compactType={ 'horizontal' }
                        isBounded={ true }
                        margin={ [ 30, 10 ] }
                        rowHeight={ 400 }
                        isResizable={ false }
                        draggableHandle={ '.drag-handle' }
                        onLayoutChange={ this.saveNewLayout }
                      >
                        <div className='layout-item' key={ 'a' }>
                          <GridItemDisplay
                            itemValue={ 'a' }
                            slide={ this.props.slides.filter( slide => slide.id === gridItems.a.slideId )[0] }
                            openSlidesSelector={ this.openSlidesSelector }
                            setSlideCallback={ (slideId) => { this.setSlide('a', slideId) } } />
                        </div>
                        <div className='layout-item' key={ 'b' }>
                          <GridItemDisplay
                            className='layout-item'
                            itemValue={ 'b' }
                            slide={ this.props.slides.filter( slide => slide.id === gridItems.b.slideId )[0] }
                            openSlidesSelector={ this.openSlidesSelector }
                            setSlideCallback={ (slideId) => { this.setSlide('b', slideId) } } />
                        </div>
                      </ResponsiveGridLayout>
                      { this.state.slidesSelectorOpenFor !== NONE && (
                        <SlidesSelector
                          slides={ this.props.slides }
                          cursorOffsetRight={ this.state.cursorOffsetRight }
                          setSlideCallback={ (slideId) => { this.setSlide(this.state.slidesSelectorOpenFor, slideId) } }
                          addNewSlide={ this.props.addNewSlide }
                          keepSlideOpen={ this.prepareForNewSlidePopupOpen }
                          onClose={ () => { this.setSlideSelectorVisibility(NONE) } } />
                      )}
                    </div>
                  </Col>
                </div>
              </li>
            )}
            { currentPage === 1 && (
              <Fragment>
                { Object.entries(gridItems).filter( ([ _, item ]) => { /*eslint-disable-line no-unused-vars*/ return item.slideId } )
                                          .sort( (pair1, pair2) => gridItemCompare(pair1[1], pair2[1]))
                                          .map( ([ gridItemIndex, gridItem ]) => (
                  <li className='form_row add-margin-top-10 add-padding-bottom-10' key={ gridItem.slideId }>
                    <div className='row popup-section-title'>
                      <Col xs={ 8 }>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.set_header_text', 
                                                            {name: `${ _.get(slides.filter( slide => slide.id === gridItem.slideId )[0], 'description') || '' }`}) }
                      </Col>
                      <Col xs={ 4 }>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.fields') }
                      </Col>
                    </div>
                    <div className='row popup-section no-padding-bottom'>
                      <Col className='no-padding-right' xs={ 8 }>
                        <CKEditor
                          id={ `${gridItem.slideId}_slide_header_content_textarea`}
                          data={ gridItems[gridItemIndex].headerText || '' }
                          onChange={ e => { this.setHeaderText(gridItemIndex, e.editor.getData()) } }
                          onInstanceReady={ (e) => {
                            const newGridItems = { ...this.state.gridItems }
                            newGridItems[gridItemIndex].editorInstance = e.editor
                            this.setState({ gridItems: newGridItems })
                            this.setEditorDefaultConfiguration(gridItemIndex, e.editor)
                            window.glg.translation.ckeditorHtmlLang(e.editor)
                          }}
                          config={{
                            toolbar: ckeditorMinimalistToolbar,
                            contentsCss: paths.ckeditorStyle,
                            resize_maxHeight: 300,
                            height: 60,
                          }} />
                      </Col>
                      <Col xs={ 4 }>
                        <div className='input_fields input_fields_height no-padding white_background'>
                          <div className='col-xs-12'>
                            { HEADER_VARS.map( ([ label, placeholder ], index) => (
                              <a
                                className='insert-in-ckeditor'
                                key={ index }
                                onClick={ () => gridItem.editorInstance.insertText(placeholder) }
                              
                                >
                                  { !window.I18n ? '' : window.I18n.t('tv_shows.constants.' + label.replace(' ', '_').toLowerCase()) }
                                </a>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </div>
                  </li>
                ))}
                <li className='form_row add-margin-top-10 add-padding-bottom-10 no-border-bottom'>
                  <div className='row popup-section-title no-padding-bottom'>
                    <Col xs={ 12 }>
                      { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.content_transition') }
                    </Col>
                  </div>
                  <div className='row popup-section vertical-align-items no-padding-bottom'>
                    <Col xs={ 12 } sm={ 6 }>
                      <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                        <Col xs={ 12 } md={ 4 } lg={ 3 }>
                          { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.scroll_rate') }
                        </Col>
                        <Col xs={ 12 } md={ 8 } lg={ 9 }>
                          <GlgRangeSlider
                            value={ this.props.scrollRate !== undefined ? this.props.scrollRate : 0 }
                            min={ 1 }
                            max={ 20 }
                            unit={ !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.seconds') }
                            onChange={ this.props.changeScrollRate } />
                        </Col>
                      </Row>
                    </Col>
                  </div>
                </li>
              </Fragment>
            )}
          </ul>
        </div>
      </GlgPopup>
    )
  }
}

const GridItemDisplay = (props) => {
  return (
    <Fragment>
      <i className='fa fa-arrows-alt drag-handle' />
      { props.slide && (
        <div className='actions-bar'>
          <button
            className='edit'
            onClick={ e => {
              e.preventDefault()
              props.openSlidesSelector(e, props.itemValue)
            } }
          >
            <i className='fa fa-pencil' />
          </button>
          <button
            className='delete'
            onClick={ e => { 
              e.preventDefault()
              props.setSlideCallback(undefined)
            } }
          >
            <i className='fa fa-trash' />
          </button>
        </div>
      )}
      <div className='layout-item-content'>
        { props.slide ? (
          <Fragment>
            <div className='type'>
              { props.slide.type }
            </div>
            <div className='description'>
              { props.slide.description }
            </div>
          </Fragment>
        ) : (
          <i className='fa fa-plus-circle' onClick={ e => props.openSlidesSelector(e, props.itemValue) } />
        )}
      </div>
    </Fragment>
  )
}

class SlidesSelector extends Component {

  constructor(props) {
    super(props)

    this.state = {
      rightStyle: 0,
    }

    this.selfRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    this.setState({
      ...this.state,
      rightStyle: this.selfRef ? Math.max(this.props.cursorOffsetRight - this.selfRef.current.offsetWidth, 0) : 0,
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside(event) {
    if ( this.selfRef && !this.selfRef.current.contains(event.target) ) {
      this.props.onClose()
    }
  }

  render() {
    const selectorStyle = {
      right: this.state.rightStyle,
    }

    return (
      <div id='slides-selector' ref={ this.selfRef } style={ selectorStyle }>
        { this.props.slides.map( slide => (
          <div className='slide-selector-option' key={ slide.id } onClick={ () => { this.props.setSlideCallback(slide.id) } }>
            <div className='type'>
              { slide.type }
            </div>
            <div className='description'>
              { slide.description }
            </div>
          </div>
        ))}
        <div
          className='slide-selector-option'
          onClick={ () => {
            this.props.keepSlideOpen()
            this.props.addNewSlide(LEADERBOARD_TYPE)
          }}
        >
          <div className='type no-margin-bottom no-border'>
            { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.advanced_slide_popup.add_new_leaderboard') }
          </div>
        </div>
      </div>
    )
  }
}

AdvancedSlidePopupComponent.propTypes = {
  slideId: PropTypes.string,
  paths: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool,
  scrollRate: PropTypes.number,
  type: PropTypes.string.isRequired,
  gridItems: PropTypes.object,
  slides: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  addNewSlide: PropTypes.func.isRequired,
  addSlide: PropTypes.func.isRequired,
  updateSlide: PropTypes.func.isRequired,
  setSlidePopupConfiguration: PropTypes.func.isRequired,
  toggleVisibilityFor: PropTypes.func.isRequired,
  setVisible: PropTypes.func,
  changeScrollRate: PropTypes.func,
}

GridItemDisplay.propTypes = {
  itemValue: PropTypes.string.isRequired,
  slide: PropTypes.object,
  openSlidesSelector: PropTypes.func.isRequired,
  setSlideCallback: PropTypes.func.isRequired,
}

SlidesSelector.propTypes = {
  slides: PropTypes.array.isRequired,
  cursorOffsetRight: PropTypes.number.isRequired,
  setSlideCallback: PropTypes.func.isRequired,
  addNewSlide: PropTypes.func.isRequired,
  keepSlideOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default AdvancedSlidePopupComponent
